import React, {useCallback, useEffect, useState} from "react";
import Page from "../../components/Page";
import {Button, Chip, Grid, Paper, Typography} from "@mui/material";
import CardHeading from "../../components/CardHeading";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {styled} from "@mui/system";
import {INVOICE_CREATE_URL, INVOICE_URL} from "../../utils/constant";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchInvoices} from "../../store/actions/invoice";
import CircularProgress from "@mui/material/CircularProgress";
import {decodeId, formatDate, formatNumber} from "../../utils/helper";
import {StyledTableCell, TableRowStyled} from "../../components/TableComponent";
import {invoiceBadgeColor, invoiceStatus} from "../../utils/statusMap";
import TableN from "../../reusableComponents/components/generics/TableN"
import PaymentFilter from "../../components/payement/PaymentFilter";

const StyledPaper = styled(Paper)(({theme}) => ({
  ...theme.paper.paper,
  margin: "1rem",
}));

export default function InvoicePage() {
  const navigate = useNavigate();

  const {error, loading} = useSelector((state) => state.invoice)

  const goToForm = useCallback(() => {
    navigate(INVOICE_CREATE_URL);
  }, [navigate])

  return (
    <Page title="Demandes de paiements" actions={(
      <>
        {false && (
          <Button
            variant="outlined"
            component="span"
            color="primary"
            onClick={goToForm}
          >
            Nouvelle facture
          </Button>
        )}
      </>
    )}>
      <Grid container>
        <Grid item xs={12}>
          <StyledPaper>
            <CardHeading
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography variant="h6">Liste des demandes de paiements</Typography>
              </Grid>
              <Grid item>
              </Grid>
            </CardHeading>

            {loading && (
              <CircularProgress/>
            )}

            {error && (
              <div>
                Une erreur s'est produite lors du chargement des données, veuillez réessayer!
              </div>
            )}

            <PaymentFilter />
            <InvoiceTable />
          </StyledPaper>
        </Grid>
      </Grid>
    </Page>
  )
}

function InvoiceTable() {

  const dispatch = useDispatch()

  const navigate = useNavigate();
  const goToDetail = (id) => {
    const url = `${INVOICE_URL}/${decodeId(id)}`
    navigate(url)
  }

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();
  const [startCursors, setStartCursors] = useState();

  const data = useSelector((state) => state.invoice)

  console.log("===> data", data)


  useEffect(() => {
    if(data) {
      setPageInfo(data?.pageInfo?.totalCount)
      setStartCursors(data?.pageInfo?.startCursor)
      setEndCursors(data?.pageInfo?.endCursor)
    }
  }, [data])


  const loadData = useCallback(() => {
    let params = buildQueryParams({
      filters: {},
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
      orderBy: ["-dateCreated"],
    });
    dispatch(fetchInvoices(params));
  }, [
    page,
    pageSize,
  ]);


  useEffect(() => {
    loadData();
  }, [
    page,
    pageSize,
    loadData
  ]);


  const headers = () => {
    var h = [
      "Numéro",
      "Soumis le",
      "Soumis par",
      "Note",
      "Montant",
      "Status",
      "Actions",
    ];
    return h;
  };

  const itemFormatters = () => {
    var row = [
        (data) => data.invoiceNumber,
        (data) => formatDate(data.dateCreated),
        (data) => data.submittedBy?.username,
        (data) => data.note,
        (data) => formatNumber(data.totalAmount),
        (data) => (
          <Chip label={invoiceStatus(data.status)} color={invoiceBadgeColor(data.status)}/>
        ),
        (data) => (
          <Button varian="outlined" href={`${INVOICE_URL}/${decodeId(data.id)}`}>Détails</Button>
        )
    ];

    return row;
  };

  const buildQueryParams = (state) => {
    let params = [];

    if (state.filters) {
      params = Object.keys(state.filters)
        .filter((f) => !!state.filters[f]["filter"])
        .map((f) => state.filters[f]["filter"]);
    }

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }

    return params;
  };


  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setEndCursors(null);
    setStartCursors(null);
    setPage(0);
  };
  const handleNavigation = (direction) => {
      if (direction === 'forward') {
          setEndCursors(null);
      } else if (direction === 'backward') {
          setStartCursors(null);
      }
  };
  const handleRowDoubleClick = (rowData) => {
      console.log(rowData,'rowData');
      navigate(`${INVOICE_URL}/${decodeId(rowData.id)}`);
  };

  return (
    <TableN
      headers={headers()}
      itemFormatters={itemFormatters()}
      items={data?.invoices ? data?.invoices : []}
      withSelection={"single"}
      withPagination={true}
      rowsPerPageOptions={[10, 50, 100]}
      defaultPageSize={5}
      page={page}
      pageSize={pageSize}
      count={pageInfo}
      onChangePage={(event, newPage) => {
          setPage(newPage);
          handleNavigation(newPage > page ? 'forward' : 'backward');
      }}
      onChangeRowsPerPage={handleRowsPerPageChange}
      onDoubleClick={handleRowDoubleClick}
    // rowLocked={this.rowLocked}
    />
  )
}